import { TaprootAddressNotSupportedError } from '../../../errors/TaprootAddressNotSupportedError';

/**
 * Validates that the address is not a Taproot address
 * Only Native SegWit (P2WPKH) is supported for PSBT building
 *
 * @param accountAddress - The account address to check
 * @throws TaprootAddressNotSupportedError if address is Taproot
 */
export const validateNotTaproot = (accountAddress: string): void => {
  if (
    accountAddress.toLowerCase().startsWith('bc1p') ||
    accountAddress.toLowerCase().startsWith('tb1p')
  ) {
    throw new TaprootAddressNotSupportedError();
  }
};
